module.exports = __webpack_public_path__ + "img/web_1.2c2981c7.png";